import script from "./HighscoreView.vue?vue&type=script&setup=true&lang=js"
export * from "./HighscoreView.vue?vue&type=script&setup=true&lang=js"

import "./HighscoreView.vue?vue&type=style&index=0&id=165b6b52&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-165b6b52"]])

export default __exports__